import "./AccessibilityStatement.module.css";
import Header from "@/reusable_sections/Header";
import Accessibility from "./sections/Accessibility";
import AccessibilityContact from "./sections/AccessibilityContact";
import Footer from "@/reusable_sections/Footer";
export default function AccessibilityStatementPage() {
  return <div>
      <Header />
      <Accessibility />
      <Accessibility />
      <AccessibilityContact />
      <Footer />
    </div>;
}